import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import ReactGA from 'react-ga';

const getElement = (disabled, to, file) => {
  if (to) {
    return disabled ? 'a' : Link;
  } else if (file) {
    return 'a';
  }

  return 'button';
};

const getButtonClasses = (disabled, customClasses) => {
  const defaultClasses = {
    'comet-button': true,
    'comet-button--primary': true,
    'comet-button--disabled': disabled
  };

  let classes;

  if (customClasses) {
    classes = Object.assign(defaultClasses, customClasses);
  } else {
    classes = defaultClasses;
  }

  return classNames(classes);
};

const Button = ({ classes, children, disabled, file, onClick, to }) => {
  const Element = getElement(disabled, to, file);
  const elementClasses = getButtonClasses(disabled, classes);
  const href = file ? file : null;
  const rel = file ? 'noopener' : null;
  const target = file ? '_blank' : null;

  const trackDownload = () => {
    if (process.env.NODE_ENV === 'production' && file) {
      ReactGA.event({
        category: 'Downloads',
        action: 'PDF',
        label: file
      });
    }
    if (onClick) {
      return onClick();
    }
  };

  return (
    <Element
      disabled={!to && disabled} // only needed if a button element
      className={elementClasses}
      href={href}
      onClick={trackDownload}
      rel={rel}
      target={target}
      to={disabled ? null : to} // only needed if a Link component
      download={href}
    >
      {children}
    </Element>
  );
};

Button.defaultProps = {
  disabled: false,
  onClick: null,
  to: null
};

Button.propTypes = {
  children: PropTypes.string.isRequired,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  file: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ../core/src/components/Button/index.js